import { default as olRotate } from 'ol/control/Rotate.js';
import {Control} from '../Control.js';

export class RotateReset extends Control {

    constructor( map, settings = {} ){
        settings["name"] = 'rotate_reset';
        if( settings['target'] == undefined ) settings['target'] = "rotate_reset";

        super( map, settings );
        
        this.control = new olRotate({
            "target": this.target,
            });
    }
}
